import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { ListaContratos } from "../../view/contratos/ListaContratos";
import { VerContrato } from "../../view/contratos/VerContrato";
import { EditarContrato } from "../../view/cotizaciones/EditarContrato";
import { GenerarContratos } from "../../view/cotizaciones/GenerarContratos";



export const PageContratos = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook

    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "contratos" && path[2] === "lista" && <ListaContratos />}
                                {path[1] === "contratos" && path[2] === "ver" && <VerContrato />}
                                {path[1] === "contratos" && path[2] === "crear" && <GenerarContratos />}
                                {path[1] === "contratos" && path[2] === "editar" && <EditarContrato />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
